module.exports = __webpack_public_path__ + "img/nopic.5c4c5c79.jpg";